import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { adminApi, imgUrl, errMsg } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { CategoryBadge } from "../site/CategoryBadge";
import { AnnouncementForm } from "./AnnouncementForm";
import { ConfirmDelete } from "./ConfirmDelete";

export const AnnouncementsManager = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [toDelete, setToDelete] = useState(null);

  const load = () => adminApi.get("/admin/announcements").then((r) => setItems(r.data));
  useEffect(() => {
    load();
  }, []);

  const remove = async () => {
    try {
      await adminApi.delete(`/admin/announcements/${toDelete.id}`);
      toast.success("Silindi");
      setToDelete(null);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div>
          <h2 className="font-display text-2xl font-bold text-slate-800">Haber & Duyurular</h2>
          <p className="text-sm text-slate-500">"Haber" türündeki son 5 kayıt ana sayfadaki büyük resimde döner.</p>
        </div>
        <button onClick={() => setEditing({})} data-testid="add-announcement-btn"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#E07A5F] hover:bg-[#c9664c] text-white font-bold transition-colors">
          <Plus size={18} /> Yeni Ekle
        </button>
      </div>
      <div className="bg-white rounded-3xl border border-black/5 divide-y divide-black/5" data-testid="admin-announcement-list">
        {items.length === 0 && <p className="p-6 text-slate-500">Henüz kayıt yok. "Yeni Ekle" ile başlayın.</p>}
        {items.map((a) => (
          <div key={a.id} className="flex items-center gap-4 p-4" data-testid={`admin-announcement-${a.id}`}>
            <img src={imgUrl(a.image_path)} alt="" className="w-16 h-12 rounded-xl object-cover hidden sm:block" />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2"><CategoryBadge category={a.category} /><span className="text-xs text-slate-400">{fmtDate(a.date)}</span></div>
              <p className="font-semibold text-slate-800 mt-1 truncate">{a.title}</p>
            </div>
            <button onClick={() => setEditing(a)} className="flex items-center gap-1 px-4 py-2 rounded-full bg-[#D8F3DC] text-[#1B4332] font-bold text-sm hover:bg-[#b7e4c7]" data-testid={`edit-announcement-${a.id}`}>
              <Pencil size={14} /> <span className="hidden sm:inline">Düzelt</span>
            </button>
            <button onClick={() => setToDelete(a)} className="flex items-center gap-1 px-4 py-2 rounded-full bg-red-50 text-red-600 font-bold text-sm hover:bg-red-100" data-testid={`delete-announcement-${a.id}`}>
              <Trash2 size={14} /> <span className="hidden sm:inline">Sil</span>
            </button>
          </div>
        ))}
      </div>
      {editing && <AnnouncementForm item={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
      <ConfirmDelete open={!!toDelete} title={toDelete?.title} onCancel={() => setToDelete(null)} onConfirm={remove} />
    </div>
  );
};
